module.exports = __webpack_public_path__ + "img/seccion4.1.6155c625.png";